import { createContext, useContext, useEffect, useState } from 'react';
import { getStoredAuth, storeAuth, clearAuth, isAuthenticated as checkAuth, getUser } from './utils/authentication';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Load auth data from localStorage on mount
    const authData = getStoredAuth();
    if (authData && checkAuth()) {
      setUser(authData);
    } else if (authData) {
      // Token expired, clear it
      clearAuth();
      setUser(null);
    }
    setLoading(false);
  }, []);

  const login = (authData) => {
    // authData: { admin, access, refresh }
    storeAuth(authData);
    setUser(authData);
  };

  const logout = () => {
    clearAuth();
    setUser(null);
    // Redirect to login
    if (typeof window !== 'undefined') {
      window.location.href = '/login';
    }
  };

  const value = {
    user: user?.admin || getUser(),
    authData: user,
    isAuthenticated: checkAuth(),
    loading,
    login,
    logout,
    // Expose access token for components that need it
    access: user?.access || null,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return ctx;
}

